import { render, staticRenderFns } from "./subnew.vue?vue&type=template&id=1a1412b3&scoped=true&"
import script from "./subnew.vue?vue&type=script&lang=js&"
export * from "./subnew.vue?vue&type=script&lang=js&"
import style0 from "./subnew.vue?vue&type=style&index=0&id=1a1412b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1412b3",
  null
  
)

export default component.exports